<template>
    <div class="label-manage">
        <div class="add-btn-left">
            <el-button type="primary" @click="addLabel()">
                <i class="el-icon-plus"></i>添加标签
            </el-button>
        </div>
        <el-table :data="labelTable"  style="width: 100%; flex: 1" height="1%" size="medium"
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                  :row-key="getRowKey" :expand-row-keys="expands"
                  :header-cell-style="{fontWeight: 'normal', color: '#666', background: '#eee',fontSize: '16px',height:'60px'}"
                  class="customTable" :cell-style="{fontSize: '12px',color: '#333',height: '70px'}">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column label="操作" align="center" width="240px">
                <template slot-scope="scope">
                    <div class="link-list">
                        <el-link type="success" v-if="scope.row.pid===0" :underline="false" @click="addLabel(scope.row)">添加子分类</el-link>
                        <el-link type="success" v-else :underline="false" style="visibility: hidden">添加子分类</el-link>
                        <el-link type="success" :underline="false" @click="editLabel(scope.row)">编辑</el-link>
                        <el-link type="primary" :underline="false" @click="deleteLabelRow(scope.row.id)">删除</el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="pages-center"
                :current-page="labelPages.currentPageNum"
                :page-size="labelPages.eachPageNum"
                layout="prev, pager, next, jumper"
                :total="labelPages.total"
                @current-change="labelCurrentChange">
        </el-pagination>
        <el-dialog :title="labelTitleType" :visible.sync="dialogAddLabel" custom-class="green-dialog centerDialog" width="500px" @close="resetForm()"  :close-on-click-modal="false">
            <el-form :model="addLabelForm" ref="addLabelForm" :rules="resourcesRules"  label-position="top">
                <el-form-item  label="标签名称" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="addLabelForm.name"  autocomplete="off" ></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button size="medium" @click="dialogAddLabel = false">取 消</el-button>
                <el-button size="medium" type="primary" plain @click="addToForm('addLabelForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {tagAdd,tagPage,tagDel} from '@/utils/apis'
    export default {
        name: "Index",
        data(){
            return{
                labelTable:[],
                dialogAddLabel:false,
                labelTitleType:'',
                distinguishBtn:'',
                expands:[],
                addLabelForm:{
                    name: '',
                    id: '',
                },
                pid:0,
                resourcesRules: {
                    name: [
                        { required: true, message: '请输入标签名称', trigger: 'blur' },
                        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                    ],
                },
                formLabelWidth:'80px',
                //分页
                labelPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0
                },
            }
        },
        mounted() {
            this.getLabelList()
            this.expands = this.getRowKeys(this.labelTable);
        },
        methods:{
            getRowKey(row) {
                return row.id;
            },
            getRowKeys(data) {
                let arr = [];
                if (data.length === 0) {
                    return arr;
                }
                arr.push(data[0].id);
                if (data[0].children && data[0].children.length > 0) {
                    let result = this.getRowKeys(data[0].children);
                    arr = arr.concat(result);
                }
                return arr;
            },
            // 添加标签组
            // addLabelGroup(){
            //     this.dialogAddLabel = true;
            //     this.labelTitleType = '添加标签组';
            // },
            // 获取标签列表
            getLabelList() {
                let param = {
                    limit:this.labelPages.eachPageNum,
                    page:this.labelPages.currentPageNum
                }
                tagPage(param).then((res) => {
                    this.labelTable = res.data.list
                    this.labelPages.total = res.data.total;
                }).catch((err) => {
                    console.error('err', err);
                });
            },
            // 添加子标签
            addLabel(row){
                if (row) {
                    this.pid = row.id;
                    this.labelTitleType = '添加二级标签'
                } else {
                    this.labelTitleType = '添加标签'
                }
                this.dialogAddLabel = true;
                this.distinguishBtn = 'add';
            },
            //编辑
            editLabel(row){
                this.addLabelForm.name = row.name;
                this.addLabelForm.id = row.id;
                if(row.pid){
                    this.labelTitleType = '编辑二级标签'
                }else {
                    this.labelTitleType = '编辑标签'
                }
                this.dialogAddLabel = true;
                this.distinguishBtn = 'edit';
            },
            //确定事件
            addToForm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let param = {};
                        if (this.labelTitleType === '添加标签'){
                            param = {
                                name: this.addLabelForm.name
                            }
                        }else{
                            param = {
                                name: this.addLabelForm.name,
                                pid:this.pid
                            }
                        }
                        if( this.distinguishBtn === 'edit'){
                            param.id=this.addLabelForm.id
                        }
                        tagAdd(param).then((res) => {
                            this.$message.success(res.msg);
                            this.dialogAddLabel = false;
                            this.getLabelList();
                            this.resetForm();
                        }).catch((err) => {
                            console.log('err', err)
                        })
                    }
                });
            },
            //删除
            deleteLabelRow(id){
                this.$confirm(`是否删除该分类，删除将无法恢复`, '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'green-message-box',
                    type: 'warning'
                }).then(() => {
                    tagDel(id).then((res) => {
                        console.log(res)
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration:1000,
                            onClose: () => {
                                this.getLabelList()
                            }
                        })
                    }).catch((err) => {
                        console.log('err', err)
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
            },
            resetForm() {
                this.$refs.addLabelForm.resetFields();
                this.addLabelForm = this.$options.data().addLabelForm;
            },
            // 切换分页
            labelCurrentChange(val){
                this.labelPages.currentPageNum = val;
                this.getLabelList();
            }
        }
    }
</script>

<style scoped lang="scss">
    .label-manage{
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0 20px;
        .add-btn-left{
            display: flex;
            justify-content: flex-end;
            padding-bottom: 20px;
        }
        .dialog-footer{
            text-align: center;
            margin-top: 20px;
        }
    }
</style>